// 事件分析 API
import axios from 'axios';
import config from 'config';
import { Cookies } from 'utils';

export const SendEventAnalyticsAPI = async eventData => {
	try {
		const tokenType = Cookies.get('token_type');
		const accessToken = Cookies.get('access_token');

		if (!tokenType || !accessToken) {
			// console.warn(
			// 	'[⚠️ Event Analytics] No token found, skipping API call'
			// );
			return;
		}

		const response = await axios.post(
			`${config.api.APP_API_DOMAIN}/user/tracking`,
			eventData,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `${tokenType} ${accessToken}`,
				},
			}
		);

		return response.data;
	} catch (error) {
		// console.error(
		// 	'[❌ Event Analytics] Failed to send tracking data',
		// 	error
		// );
		return null;
	}
};
